export const LABEL_CACHE_KEY = 'editingLabel'

export const createLabelValidation = (overrides = {}) => ({
  nameTh: '',
  nameEn: '',
  nameZh: '',
  ...overrides
});

export const labelValidationRules = {
  nameTh: [
    { required: true, message: 'กรุณาระบุชื่อภาษาไทย', trigger: 'blur' },
    { min: 1, max: 25, message: 'ชื่อต้องมีความยาวไม่เกิน 25 ตัวอักษร', trigger: 'blur' }
  ],
  nameEn: [
    { max: 25, message: 'ชื่อต้องมีความยาวไม่เกิน 25 ตัวอักษร', trigger: 'blur' }
  ],
  nameZh: [
    { max: 25, message: 'ชื่อต้องมีความยาวไม่เกิน 25 ตัวอักษร', trigger: 'blur' }
  ]
};
